import { useState } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useBoolean } from 'ahooks';
import {
  Button,
  Modal,
  Radio,
  Row,
  Space,
} from 'antd';

import { MilesText } from 'components';

import { useGetRequest } from 'hooks';

import { ClaimFeedbacks, SnapClaimUnflagRequest } from 'codegen';
import { TRequestCallback } from 'types';

export const DeclineButton = ({
  loading,
  handleClaim,
}: {
  loading: boolean;
  handleClaim: TRequestCallback<SnapClaimUnflagRequest>;
}) => {
  const [isOpen, { setFalse, setTrue }] = useBoolean();
  const [feedbackId, setClaimId] = useState(0);

  const { data, loading: feeedbacksLoading } = useGetRequest<ClaimFeedbacks>({
    url: '/claims/feedbacks',
    queryParams: {
      resolutionStatus: 'DECLINED',
      status: 'ACTIVE',
    },
    options: {
      ready: isOpen,
      // onSuccess: ({ data: res }) => console.log(res),
    },
  });

  const feedbacks = data?.feedbacks;

  return (
    <>
      <Modal
        open={isOpen}
        title='Decline The Claim'
        okText='Decline'
        confirmLoading={loading || feeedbacksLoading}
        onOk={() => handleClaim({ payload: { feedbackId, resolutionStatus: SnapClaimUnflagRequest.resolutionStatus.DECLINED } })}
        onCancel={setFalse}
        afterClose={() => setClaimId(0)}
        cancelButtonProps={{ loading: loading || feeedbacksLoading }}
        okButtonProps={{
          icon: <CloseCircleOutlined />,
          danger: true,
          loading: loading || feeedbacksLoading,
          disabled: !feedbackId,
        }}
      >
        <Row className='mb-10'>
          <MilesText>
            To send proceed with claim resolution please select one option from the list:
          </MilesText>
        </Row>

        <Radio.Group
          value={feedbackId}
          onChange={({ target }) => setClaimId(target.value)}
        >
          <Space direction='vertical'>
            {feedbacks?.map(({ id, resolutionReason }) => (
              <Radio key={id} value={id}>{resolutionReason}</Radio>
            ))}
          </Space>
        </Radio.Group>
      </Modal>

      <Button
        danger
        size='small'
        type='primary'
        icon={<CloseCircleOutlined />}
        onClick={setTrue}
        loading={loading}
        className='mr-5'
      >
        Decline
      </Button>
    </>
  );
};
